import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=5ffc4790&scoped=true&"
import script from "./NotesList.vue?vue&type=script&lang=js&"
export * from "./NotesList.vue?vue&type=script&lang=js&"
import style0 from "./NotesList.vue?vue&type=style&index=0&id=5ffc4790&lang=scss&scoped=true&"
import style1 from "./NotesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc4790",
  null
  
)

export default component.exports